<template>
    <section class="block block-top-educations">
        <div class="container-fluid">
            <div class="row position-relative">
                <div class="col-12 col-xl-5">
                    <h2 v-if="title" class="h1 font-weight-bold uppercase">
                        {{ title }}
                    </h2>
                </div>
                <div class="col-12 col-xl-10">
                    <div class="block-top-educations__wrapper mb-1">
                        <education-top-pick
                            v-for="(education, index) in educations"
                            :key="education.id"
                            :education="education"
                            :rank="index + 1"
                        ></education-top-pick>
                    </div>
                    <div
                        v-if="button"
                        class="text-left position-relative educations__button"
                        data-aos="fade-up"
                    >
                        <a
                            :href="button.url"
                            :target="button.target"
                            class="btn btn-primary"
                        >
                            {{ button.caption }}
                        </a>
                    </div>
                </div>
                <div
                    v-if="image"
                    class="col-12 col-md-7 d-none d-xl-block educations__background-wrapper position-absolute"
                >
                    <div class="educations__background">
                        <lazy-background :image="image"></lazy-background>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import LazyBackground from '@/components/lazy-background';
import EducationTopPick from '@/components/education/education-top-pick';
export default {
    components: {
        EducationTopPick,
        LazyBackground
    },
    props: {
        educations: {
            type: Array,
            default() {
                return [];
            }
        },
        title: {
            type: String,
            default() {
                return '';
            }
        },
        image: {
            type: Object,
            default() {
                return {};
            }
        },
        button: {
            type: Object,
            default() {
                return {};
            }
        }
    }
};
</script>

<style lang="scss">
.educations__background-wrapper {
    right: 0;
}

.educations__background {
    position: relative;
    overflow: hidden;
    width: 100%;
    padding-top: 75%;
    background-size: cover;
}

.educations__button {
    position: relative;
    z-index: 1;
}

.block-top-educations h2 {
    font-family: $font-family-condensed;

    @include media-breakpoint-up(md) {
        font-size: 3.125rem;
    }
}

.block-top-educations__wrapper {
    margin: 0 -20px;
    padding: 20px 0;
    z-index: 20;
    position: relative;

    @include media-breakpoint-up(xl) {
        columns: 1;
        column-gap: 0;
        width: 50%;
    }
}
</style>
